import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function CloseIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" title="Close Menu" {...props}>
      <path
        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
        transform="translate(-335.000000, -23.000000) translate(335.000000, 23.000000)"
      />
    </SvgIcon>
  );
}

export default CloseIcon;
